import { AlertTriangle, Clock, Users, FileX, TrendingDown, Shield } from "lucide-react";

const signs = [
  { icon: Clock, text: "Decisões importantes sempre adiadas para \"não piorar o clima\"", priority: 1 },
  { icon: TrendingDown, text: "O negócio cresce, mas a relação entre sócios se desgasta", priority: 2 },
  { icon: Users, text: "As reuniões entre sócios ficam mais longas… e menos produtivas", priority: 3 },
  { icon: AlertTriangle, text: "Conversas estratégicas viram disputas pessoais" },
  { icon: FileX, text: "O acordo societário existe, mas ninguém mais o segue" },
  { icon: Shield, text: "O patrimônio e legado estão em risco" },
];

const SignsSection = () => (
  <section className="section-dark py-14 md:py-20">
    <div className="container mx-auto px-6">
      <p className="text-primary font-body font-semibold tracking-widest uppercase text-[13px] mb-5">Atenção</p>
      <h2 className="text-[25px] md:text-[31px] lg:text-[39px] font-heading font-bold leading-[1.2em] tracking-[-1px] mb-14 text-surface-dark-foreground">
        Os sinais que ninguém gosta de admitir
      </h2>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
        {signs.map((sign, i) => (
          <div
            key={i}
            className="group border border-accent-subtle rounded-lg p-6 hover:glow-accent transition-all duration-300 bg-surface-darker/50"
          >
            <sign.icon className="w-7 h-7 text-primary mb-4 group-hover:scale-110 transition-transform" />
            <p className="text-surface-dark-foreground/90 font-body text-[16px] font-normal leading-[1.5em]">{sign.text}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default SignsSection;
